import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import {Button, Col, Form, FormGroup, Input, Row, Label, UncontrolledTooltip} from "reactstrap";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ReportButtons from 'components/common/ReportButtons'
import { Document, Packer, Table, TableRow, TableCell, Paragraph, TextRun, WidthType, AlignmentType, VerticalAlign, convertMillimetersToTwip } from 'docx';

// import { getMaterials, postMaterial } from 'actions/procedureDefActions';

const ProceduresCostList = ({procedures, opk, editRow}) => {
  let title = 'Zestawienie jednostkowych kosztów normatywnych procedur/usług'
  if(opk!==null){
    title+=' dla '+opk.value
  }
    const getTableRow = (values, format={}) => {
        let row = []
        values.forEach( (val, i) => {
          row.push(new TableCell({
            children: [
              new Paragraph({
                children: [new TextRun({ 
                  text: String(val), 
                  font:'Calibri', 
                  bold: format.bold, 
                  color: format.textColor,
                  size: format.size,
                  allCaps: format.allCaps
                })],
                alignment: format.align[i]
              })
            ],
            verticalAlign: VerticalAlign.CENTER,
            shading: {
              fill: format.backgroundColor
            },
            margins: {
              marginUnitType: WidthType.DXA,
              top: 100, bottom: 100, left: 100, right: 100
            }
          }))
        })
        return row
      }
      
      const downloadDoc = () => {
        //TABLE
        let rows = []
        const headerStyle = {
          bold: true, backgroundColor:'#b6b6b6', textColor: 'white', size: '22', allCaps: true,
          align: Array(7).fill(AlignmentType.CENTER)
        }
        const bodyStyle = {
          bold: false, backgroundColor:'white', textColor: 'black', size: '24', allCaps: false,
          align: Array(4).fill(AlignmentType.LEFT).concat(Array(3).fill(AlignmentType.RIGHT))
        }
        //header
        rows.push(new TableRow({
            children: getTableRow([
                'Lp.',
                'Kod procedury wg klasyfikacji ICD-9 ',
                'Kod procedury wg świadczeniodawcy ',
                'Nazwa procedury ',
                'Koszty materiałowe zł ',
                'Koszty osobowe w zł ',
                'Łącznie jednostkowy koszt normatywny w zł ',
            ], headerStyle),
            tableHeader: true
        }))
        //body
        procedures.map((elem, i) => {
          rows.push(new TableRow({
            children: getTableRow([
                i,
                elem.icd_code_slow,
                elem.icd_code,
                elem.name,
                parseFloat(elem.material_cost_value).toFixed(2).toString().replace('.',','),
                parseFloat(elem.personal_cost_value).toFixed(2).toString().replace('.',','),
                (parseFloat(elem.personal_cost_value)+parseFloat(elem.material_cost_value)).toFixed(2).toString().replace('.',',')
            ], bodyStyle)
          }))
        })
    
        let table = new Table({
          rows: rows,
          width: { size: 100, type: WidthType.PERCENTAGE}
        })
    
        //DOCUMENT
        let paragraphs = [
          new Paragraph({
            children:[
              new TextRun({text: title+'\n\n', font:'Calibri', bold: true, size: 26 })
            ],
            alignment: AlignmentType.JUSTIFIED,
            spacing: { after: 200 }
          }),
          table
        ]
    
        let doc = new Document({ 
          sections: [{
            properties: { page: { 
              margin: {
                  top: convertMillimetersToTwip(15),
                  right: convertMillimetersToTwip(15),
                  bottom: convertMillimetersToTwip(15),
                  left: convertMillimetersToTwip(15),
              },
            }},
            children: paragraphs
          }] 
        })
    
        // doc.Settings.addCompatibility().doNotExpandShiftReturn();
    
        Packer.toBlob(doc).then(blob =>{
          saveAs(blob, title+'.doc')
        })
      }
    const downloadCSV = () => {
        let filename = title+'.csv';
        var tableSelect = document.getElementById('tabelaJednostkowe')
        var tableHTML = tableSelect.outerHTML;
        var csv = [];
        var rows = document.querySelectorAll(`#tabelaJednostkowe tr`);
        
        for (var i = 0; i < rows.length; i++) {
            var row = [], cols = rows[i].querySelectorAll("td, th");
            
            for (var j = 0; j < cols.length; j++)
            if(j===1 && i===0){row.push('KOD PROCEDURY WG KLASYFIKACJI ICD-9')} 
            else if(j===2 && i===0){row.push('KOD PROCEDURY WG ŚWIADCZENIODAWCY')} 
            else if(j===6 && i===0){row.push('ŁĄCZNIE JEDNOSTKOWY KOSZT NORMATYWNY W ZŁ')} 
            else{   row.push(cols[j].innerText);} 
            
            csv.push(row.join(";"));		}
            csv = csv.join("\n")

        var csvFile;
        var downloadLink;
        var universalBOM = "\uFEFF";
        csvFile = new Blob(['\ufeff',csv], {type: "text/csv;charset=UTF-8"});
        downloadLink = document.createElement("a");
        downloadLink.download = filename;
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
    }
    const downloadXlsx = () =>{
        var wb = XLSX.utils.table_to_book(document.getElementById('tabelaJednostkowe'), {sheet:"procedury", raw:true});
            var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
            let filename = title+'.xlsx';
            saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), filename);
    }
    const s2ab = (s)=>{
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
   
    
  
    return (<div className="content">
        <ReportButtons downloadDoc={downloadDoc} downloadCSV={downloadCSV} downloadXlsx={downloadXlsx} color='wycena'/>
            <table className='table table-border tableWycena' id='tabelaJednostkowe'>
                <thead className=''>
                <tr className=''>
                    <th className="headerColor">Lp.</th>
                    <th className="headerColor">Kod procedury<br/> wg klasyfikacji ICD-9 </th>
                    <th className="headerColor">Kod procedury<br/> wg świadczeniodawcy </th>
                    <th className="headerColor">Nazwa procedury </th>
                    <th className="headerColor">Koszty materiałowe zł </th>
                    <th className="headerColor">Koszty osobowe w zł </th>
                    <th className="headerColor">Łącznie jednostkowy<br/> koszt normatywny  w zł </th>
                    <th>Opcje</th>
                </tr>
                </thead>
                <tbody>
                {procedures && procedures.map((elem, i) => {
                    return <>
                        <tr style={!elem.show_procedure?{backgroundColor:"#fafafa", color:"#616161"}:{}}>
                            <td className="cellCenter">{i+1}</td>
                            <td className="leftAlignCell">{elem.icd_code_slow}</td>
                            <td className="leftAlignCell">{elem.icd_code}</td>
                            <td className="leftAlignCell">{elem.name}</td>
                            <td className="rightAlignCell">{parseFloat(elem.material_cost_value).toFixed(2).toString().replace('.',',')}</td>
                            <td className="rightAlignCell">{parseFloat(elem.personal_cost_value).toFixed(2).toString().replace('.',',')}</td>
                            <td className="rightAlignCell">{(parseFloat(elem.personal_cost_value)+parseFloat(elem.material_cost_value)).toFixed(2).toString().replace('.',',')}</td>
                            <td className="cellCenter text-wycena">
                              {elem.show_procedure ?<i class="far fa-eye-slash" id={"iconHide"+i } style={{cursor:"pointer"}} onClick={()=>{editRow(elem.show_procedure, elem.id)}}></i>:<i style={{cursor:"pointer"}}  id={"iconHide"+i } class="fas fa-eye"  onClick={()=>{editRow(elem.show_procedure, elem.id)}}></i>}
                              <UncontrolledTooltip delay={0} placement="top" target={"iconHide"+i }>
                                  {elem.show_procedure?"Ukryj procedurę":"Prywróć procedurę" }
                              </UncontrolledTooltip>
                              </td>
                        </tr>

                    </>
                })}
                </tbody>
            </table>
            {/* <Button type='button' onClick={()=>{changeStatusProcedures(false)}}>pokaz</Button> */}
            

        </div>
    )
}
// const mapStateToProps = state => ({
//     materials:state.procedureDefReducer.materials})
export default ProceduresCostList
